import './BetbookTile.less';

import React from 'react';
import clsx from 'clsx';
import RouteLink from '../../../common/routing/RouteLink';
import { NikeRoute } from '../../../common/routing/types';

interface BetbookTileProps {
    route?: NikeRoute;
    params?: Record<string, any>;
    searchParams?: Record<string, any>;
    label: React.ReactNode;
    icon: React.ReactNode;
    description?: React.ReactNode;
    className?: string;
    dataAtid?: string;
}
const BetbookTile = ({
    route,
    params,
    searchParams,
    label,
    icon,
    description,
    className,
    dataAtid
}: BetbookTileProps) => (
    <RouteLink
        route={route}
        params={params}
        searchParams={searchParams}
        className={clsx('betbook-tile-box', className)}
        data-atid={dataAtid}
    >
        <div className="betbook-tile-icon">{icon}</div>
        <div className="betbook-tile-label">{label}</div>
        {description ? <div className="betbook-title-description c-default">{description}</div> : null}
    </RouteLink>
);

export default BetbookTile;
